// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8d09ca2fd7097fe183379dea45d4ba7ca44996e9/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};